export const FREE_DELIVERY_INFO_TEST_ID = {
  free: 'delivery-free-banner',
};
